import React, { createContext, useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { BASE_URL } from '../Globalapi/Globalapi';

const LocationContext = createContext();

export const useLocation = () => useContext(LocationContext);

export const LocationProvider = ({ children }) => {
    const [nations, setNations] = useState([]);
    const [states, setStates] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [genders, setGenders] = useState([]);
    const [bloodGroups, setBloodGroups] = useState([]);

    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                const [nationsResponse, gendersResponse, bloodGroupsResponse] = await Promise.all([
                    axios.get(`${BASE_URL}/admin/staff/nation_master.php`),
                    axios.get(`${BASE_URL}/admin/staff/gender_master.php`),
                    axios.get(`${BASE_URL}/admin/staff/blood_group_master.php`)
                ]);

                setNations(nationsResponse.data.data || []);
                setGenders(gendersResponse.data.data || []);
                setBloodGroups(bloodGroupsResponse.data.data || []);
            } catch (error) {
                console.error('Error fetching initial data:', error);
            }
        };

        fetchInitialData();
    }, []);

    const fetchStatesByNation = async (nationId) => {
        try {
            const response = await axios.get(`${BASE_URL}/admin/staff/state_master.php`);
            const filteredStates = response.data.data.filter(state => state.nation_id === nationId);
            setStates(filteredStates);
            setDistricts([]); // Clear districts when nation changes
        } catch (error) {
            console.error('Error fetching states:', error);
        }
    };

    const fetchDistrictsByState = async (stateId) => {
        try {
            console.log("Fetching districts for stateId:", stateId); // Log the stateId
    
            const response = await axios.get(`${BASE_URL}/admin/staff/district_master.php?state_id=${stateId}`);
    
            console.log("Response from districts API:", response); // Log the full response
    
            if (response.data && response.data.data) {
                setDistricts(response.data.data);
            } else {
                console.error('Districts data is undefined or empty:', response);
            }
        } catch (error) {
            console.error('Error fetching districts:', error);
        }
    };
    

    return (
        <LocationContext.Provider value={{ nations, states, districts, fetchStatesByNation, fetchDistrictsByState, genders, bloodGroups }}>
            {children}
        </LocationContext.Provider>
    );
};
